import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";
import { Bounce, toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import SelectGroup from "./SelectGroup";


interface EditDeadlineModalProps {
  show: boolean;
  onHide: () => void;
  id_program: number | null;
  onSuccess?: () => void;
}

interface Driver {
  id_conducteur: number;
  nom_conducteur: string;
  prenom_conducteur: string;
}
const wilayas = [
  "Adrar",
  "Chlef",
  "Laghouat",
  "Oum El Bouaghi",
  "Batna",
  "Béjaïa",
  "Biskra",
  "Béchar",
  "Blida",
  "Bouira",
  "Tamanrasset",
  "Tébessa",
  "Tlemcen",
  "Tiaret",
  "Tizi Ouzou",
  "Algiers",
  "Djelfa",
  "Jijel",
  "Sétif",
  "Saïda",
  "Skikda",
  "Sidi Bel Abbès",
  "Annaba",
  "Guelma",
  "Constantine",
  "Médéa",
  "Mostaganem",
  "Msila",
  "Mascara",
  "Ouargla",
  "Oran",
  "El Bayadh",
  "Illizi",
  "Bordj Bou Arreridj",
  "Boumerdès",
  "El Tarf",
  "Tindouf",
  "Tissemsilt",
  "El Oued",
  "Khenchela",
  "Souk Ahras",
  "Tipaza",
  "Mila",
  "Aïn Defla",
  "Naâma",
  "Aïn Témouchent",
  "Ghardaïa",
  "Relizane",
];
const typeOptions = ["Delivery", "Return", "Transfer", "Other"];
const statusOptions = ["planned", "in_progress", "completed", "canceled"];

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const EditDeadlineModal: React.FC<EditDeadlineModalProps> = ({
  show,
  onHide,
  id_program,
  onSuccess,
}) => {
  const [formData, setFormData] = useState({
    program_date: new Date().toISOString().split("T")[0], // valeur par défaut valide
    id_client: "",
    departure: "",
    destination: "",
    type: "",
    id_conducteur: "",
    id_vehicle: "",
    observation: "",
    status: "",
  });

  const { translate } = useTranslate();
  const [drivers, setDrivers] = useState<Driver[]>([]);
  type Driver = {
    id_conducteur: number;
    nom_conducteur: string;
    prenom_conducteur: string;
  };

  type Vehicle = {
    id_vehicule: number;
    immatriculation_vehicule: string;
  };

  type Client = {
    id_client: number;
    client_name: string;
  };

  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [clients, setClients] = useState<Client[]>([]);

  const geopuserID =
    localStorage.getItem("GeopUserID") || localStorage.getItem("userid");
  useEffect(() => {
    if (!show) return;
    if (!backendUrl) return;

    console.log("geopuserID in EditProgram:", geopuserID);

    const fetchDrivers = async () => {
      try {
        const url = geopuserID
          ? `${backendUrl}/api/program/drivers/${geopuserID}`
          : `${backendUrl}/api/program/drivers`;
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch drivers");
        const data = await response.json();
        console.log("Drivers API data:", data);
        setDrivers(
          data
            .filter(
              (driver: any) =>
                driver.nom_conducteur?.trim() !== "" &&
                driver.prenom_conducteur?.trim() !== ""
            )
            .map((driver: any) => ({
              id_conducteur: driver.id_conducteur,
              nom_conducteur: driver.nom_conducteur,
              prenom_conducteur: driver.prenom_conducteur,
            }))
        );
      } catch (error) {
        console.error("Error fetching drivers:", error);
        setDrivers([]);
      }
    };

    const fetchVehicles = async () => {
      try {
        const url = geopuserID
          ? `${backendUrl}/api/program/vehicles/${geopuserID}`
          : `${backendUrl}/api/program/vehicles`;
        const res = await fetch(url);
        if (!res.ok) throw new Error("Failed to fetch vehicles");
        const json = await res.json();
        console.log("Vehicles API data:", json);
        setVehicles(Array.isArray(json) ? json : []);
      } catch (err) {
        console.error("Error fetching vehicles:", err);
        setVehicles([]);
      }
    };

    const fetchClients = async () => {
      try {
        const url = geopuserID
          ? `${backendUrl}/api/program/clients/${geopuserID}`
          : `${backendUrl}/api/program/clients`;
        const res = await fetch(url);
        if (!res.ok) throw new Error("Failed to fetch clients");
        const json = await res.json();
        console.log("Clients API data:", json);
        setClients(Array.isArray(json) ? json : []);
      } catch (err) {
        console.error("Error fetching clients:", err);
        setClients([]);
      }
    };

    const fetchProgramDetails = async () => {
      if (!id_program) return;
      try {
        const res = await fetch(`${backendUrl}/api/program/${id_program}`);
        if (!res.ok) throw new Error("Failed to fetch program details");
        const data = await res.json();
        console.log("Program details:", data);

         const formattedDate = data.program_date
      ? new Date(data.program_date).toISOString().split("T")[0]
      : "";

        setFormData({
          program_date: formattedDate,
          id_client: data.id_client || "",
          departure: data.departure || "",
          destination: data.destination || "",
          type: data.type || "",
          id_conducteur: data.id_conducteur || "",
          id_vehicle: data.id_vehicle || "",
          observation: data.observation || "",
          status: data.status || "",
        });
      } catch (err) {
        console.error("Error fetching program:", err);
        toast.error("Error loading program details");
      }
      console.log("Fetching program details for:", id_program);
      console.log("URL:", `${backendUrl}/api/program/${id_program}`);
    };

    // Call all fetch functions
    fetchDrivers();
    fetchVehicles();
    fetchClients();
    fetchProgramDetails();
  }, [show, backendUrl, geopuserID, id_program]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleTypeChange = async (selectedOption: any) => {
    setFormData((prevData) => ({
      ...prevData!,
      id_client: selectedOption.value,
    }));
  };


  const validateForm = () => {
    // Vérifier si tous les champs sont remplis
    if (
      !formData.program_date ||
      !formData.id_client ||
      !formData.departure ||
      !formData.destination ||
      !formData.type ||
      !formData.id_conducteur ||
      !formData.id_vehicle ||
      !formData.status
    ) {
      toast.error("Please fill out all fields.", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });
      return false;
    }

    // Vérifier que la date de début est antérieure à la date de fin
    const programDate = new Date(formData.program_date); // Convertir en objet Date
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time

    if (programDate < today) {
      toast.error("Program date cannot be in the past.", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const id_user =
        localStorage.getItem("GeopUserID") ||
        localStorage.getItem("userid") ||
        "";
      const response = await fetch(
        `${backendUrl}/api/program/update/${id_program}/${id_user}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Error updating program.");
      }

      toast.success("Program updated successfully!", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });

      if (onSuccess) onSuccess();
      onHide();
    } catch (error) {
      console.error("Error updating program:", error);
      toast.error("Error updating program. Please try again.", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{translate("Update")}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="row g-3"> {/* g-3 = gap entre les colonnes */}

            {/* Program Date */}
            <div className="col-12 col-md-6">
              <Form.Group controlId="program_date">
                <Form.Label>{translate("Program Date")}</Form.Label>
                <Form.Control
                  type="date"
                  value={formData.program_date}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>

            {/* Client */}
            <div className="col-12 col-md-6">
              <SelectGroup
                controlId="id_client"
                name="id_client"
                label={translate("Client")}
                icon="user"
                options={clients.map(c => ({
                  value: c.id_client,
                  label: c.client_name,
                }))}
                valueType={{
                  value: formData.id_client || "",
                  label: clients.find(c => c.id_client === Number(formData.id_client))?.client_name
                    || translate("Select Client"),
                }}
                onChange={(selected) => setFormData(prev => ({
                  ...prev,
                  id_client: String(selected.value),
                }))}
              />
            </div>

            {/* Departure */}
            <div className="col-12 col-md-6">
              <SelectGroup
                controlId="departure"
                name="departure"
                label={translate("Departure")}
                icon="map-marker-alt"
                options={wilayas.map(w => ({ value: w, label: w }))}
                valueType={{
                  value: formData.departure || "",
                  label: formData.departure || translate("Select departure"),
                }}
                onChange={(selected) => setFormData(prev => ({
                  ...prev,
                  departure: selected.value,
                }))}
              />
            </div>

            {/* Destination */}
            <div className="col-12 col-md-6">
              <SelectGroup
                controlId="destination"
                name="destination"
                label={translate("Destination")}
                icon="map-marker-alt"
                options={wilayas.map(w => ({ value: w, label: w }))}
                valueType={{
                  value: formData.destination || "",
                  label: formData.destination || translate("Select destination"),
                }}
                onChange={(selected) => setFormData(prev => ({
                  ...prev,
                  destination: selected.value,
                }))}
              />
            </div>

            {/* Type */}
            <div className="col-12 col-md-6">
              <Form.Group controlId="type">
                <Form.Label>{translate("Type")}</Form.Label>
                <Form.Control
                  as="select"
                  value={formData.type}
                  onChange={handleChange}
                >
                  <option value="">{translate("Select type")}</option>
                  {typeOptions.map(t => <option key={t} value={t}>{t}</option>)}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Driver */}
            <div className="col-12 col-md-6">
              <SelectGroup
                controlId="id_conducteur"
                name="id_conducteur"
                label={translate("Driver")}
                icon="user-tie"
                options={drivers.map(d => ({
                  value: d.id_conducteur,
                  label: `${d.prenom_conducteur} ${d.nom_conducteur}`,
                }))}
                valueType={{
                  value: formData.id_conducteur || "",
                  label: drivers.find(d => d.id_conducteur === Number(formData.id_conducteur))
                    ? `${drivers.find(d => d.id_conducteur === Number(formData.id_conducteur))?.prenom_conducteur} ${drivers.find(d => d.id_conducteur === Number(formData.id_conducteur))?.nom_conducteur}`
                    : translate("Select Driver"),
                }}
                onChange={(selected) => setFormData(prev => ({
                  ...prev,
                  id_conducteur: String(selected.value),
                }))}
              />
            </div>

            {/* Vehicle */}
            <div className="col-12 col-md-6">
              <SelectGroup
                controlId="id_vehicle"
                name="id_vehicle"
                label={translate("Vehicle")}
                icon="truck"
                options={vehicles.map(v => ({
                  value: v.id_vehicule,
                  label: v.immatriculation_vehicule || `#${v.id_vehicule}`,
                }))}
                valueType={{
                  value: formData.id_vehicle || "",
                  label: vehicles.find(v => v.id_vehicule === Number(formData.id_vehicle))
                    ? vehicles.find(v => v.id_vehicule === Number(formData.id_vehicle))?.immatriculation_vehicule || `#${formData.id_vehicle}`
                    : translate("Select Vehicle"),
                }}
                onChange={(selected) => setFormData(prev => ({
                  ...prev,
                  id_vehicle: String(selected.value),
                }))}
              />
            </div>

                {/* Status */}
            <div className="col-12 col-md-6">
              <Form.Group controlId="status">
                <Form.Label>{translate("Status")}</Form.Label>
                <Form.Control
                  as="select"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="">{translate("Select status")}</option>
                  {statusOptions.map(s => <option key={s} value={s}>{s}</option>)}
                </Form.Control>
              </Form.Group>
            </div>

            {/* Observation */}
            <div className="col-12 col-md-12">
              <Form.Group controlId="observation">
                <Form.Label>{translate("Observation")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={formData.observation}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>

        

          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {translate("Close")}
          </Button>
          <Button variant="primary" type="submit">
            {translate("Update")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>

  );
};

export default EditDeadlineModal;
